import { render, staticRenderFns } from "./vw-flat-rate-search-view.vue?vue&type=template&id=78777831&scoped=true&"
import script from "./vw-flat-rate-search-view.vue?vue&type=script&lang=js&"
export * from "./vw-flat-rate-search-view.vue?vue&type=script&lang=js&"
import style0 from "./vw-flat-rate-search-view.vue?vue&type=style&index=0&id=78777831&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78777831",
  null
  
)

export default component.exports